/** Padrões neutros: nenhum endereço de infraestrutura específica é assumido pelo bundle. */
export const CONFIGURACAO_PADRAO = {
    apiBaseUrl: '/api/v1',
    environment: 'nao-informado',
    mapStyleUrl: null,
    apiToken: null,
};
function texto(valor) {
    if (typeof valor !== 'string') {
        return null;
    }
    const limpo = valor.trim();
    return limpo === '' ? null : limpo;
}
function normalizarBase(valor) {
    return valor.replace(/\/+$/, '');
}
/** Lê e normaliza a configuração injetada, sem falhar quando `config.js` não foi carregado. */
export function lerConfiguracao(escopo = window) {
    const bruta = escopo.__VIEWER_CONFIG__ ?? {};
    const apiBaseUrl = texto(bruta.apiBaseUrl);
    const environment = texto(bruta.environment);
    const mapStyleUrl = texto(bruta.mapStyleUrl);
    const apiToken = texto(bruta.apiToken);
    return {
        apiBaseUrl: apiBaseUrl === null ? CONFIGURACAO_PADRAO.apiBaseUrl : normalizarBase(apiBaseUrl),
        environment: environment ?? CONFIGURACAO_PADRAO.environment,
        mapStyleUrl,
        apiToken,
    };
}
let configuracao = null;
/** Devolve a configuração resolvida uma única vez por carregamento da página. */
export function obterConfiguracao() {
    configuracao ??= lerConfiguracao();
    return configuracao;
}
/** Reinicia o cache da configuração. Usado apenas pelos testes. */
export function redefinirConfiguracao() {
    configuracao = null;
}
